<app-dialog-base class="modalgroupaccess" *ngIf="isDialogVisible" [dialogId]="dialogId"
  [Title]="(dialogMode === DialogMode.Create ? 'Create group' : 'Edit group') | translate" [width]="'980px'"
  [height]="'640px'" (onClose)="closeDialog()">
  <div class="dialog-body">
    <div class="btn_tabs">
      <button (click)="openTab('objects')" [class.active]="isSelected('objects')">{{'Objects'|translate}}</button>
      <button (click)="openTab('users')" [class.active]="isSelected('users')">{{'Access rights'|translate}}</button>
    </div>
    <div class="horseparator"></div>

    <div class="group-editor"
      *ngIf="(dialogMode === DialogMode.Create && isEditable) || (dialogMode === DialogMode.Edit && selectedGroupDetails?.Id > 0)">
      <form class="group-editor-body" *ngIf="groupForm || dialogMode === DialogMode.Edit" [formGroup]="groupForm">
        <div *ngIf="isSelected('objects')">
          <div class="inputgroup">
            <label>{{'Name'|translate}}</label>
            <input type="text" [(ngModel)]="activeGroupName" [ngModelOptions]="{standalone: true}" required />
          </div>
          <div class="validation" *ngIf="groupForm?.get('name')?.touched && groupForm?.get('name')?.invalid">
            {{'The name field is required'|translate}}
          </div>
          <div class="group-objects">
            <div class="tablewrap admindrivers objects-tablewrap">
              <div class="table">
                <table fixedcols="[0]" class="objects-table">
                  <tr>
                    <th>
                      <switch-all-checkbox [items]="activeSelectedObjects" />
                    </th>
                    <th>{{'Name'|translate}}</th>
                    <th>
                      <div class="objects-actions">
                        <button class="btnadd" type="button" (click)="openObjectsPickerForMode()"
                          [disabled]="!isEditable || !isAclContextReady"></button>
                        <button class="btn_img btn_remove" type="button" (click)="removeAllSelectedObjects()"
                          [disabled]="!isEditable || !isAclContextReady || activeSelectedObjects.length === 0"
                          title="{{'Clear'|translate}}"></button>
                      </div>
                    </th>
                  </tr>
                  <tr *ngFor="let item of activeSelectedObjects">
                    <td>
                      <input type="checkbox" [(ngModel)]="item.IsChecked" [ngModelOptions]="{standalone: true}" />
                    </td>
                    <td>
                      <span class="object-name" [title]="item.Name">{{item.Name}}</span>
                    </td>
                    <td>
                      <button class="btn_img btn_trush" type="button" (click)="removeSelectedObject(item)"></button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="group-users-panel" *ngIf="isSelected('users')">
          <div class="access-body">
            <div class="users-panel">
              <div class="inputgroup group-users-controls">
                <label>{{'Users'|translate}}</label>
                <button class="btnadd" style="padding-left: 20px;" type="button" (click)="openUsersPickerForMode()"
                  [disabled]="!canManageMembers()"></button>
              </div>

              <div class="filter-row">
                <input class="searchinput" type="text" placeholder="{{'Search'|translate}}"
                  [(ngModel)]="activeSearchTerm" [ngModelOptions]="{standalone: true}" />
              </div>

              <div class="users-list">
                <div class="user-item" *ngFor="let item of filteredActiveUsers"
                  [class.active]="activeSelectedUser?.userId == item.userId" (click)="selectUserUnified(item)">
                  <div class="user-text">
                    <div class="username" [title]="item.name">{{ !item.name ? "****" : item.name }}</div>
                    <div class="useremail" *ngIf="item.companyId" [title]="getCompanyName(item.companyId)">
                      {{getCompanyName(item.companyId)}}</div>
                  </div>
                  <button class="btn_img btn_trush" *ngIf="item.userId !== currentUserId && canManageMembers()"
                    (click)="removeUser(item); $event.stopPropagation()"></button>
                  <div *ngIf="item.userId == currentUserId"></div>
                </div>
              </div>

              <div class="empty-users" *ngIf="filteredActiveUsers.length == 0">
                {{'No users in group'|translate}}
              </div>
            </div>

            <div class="rights-panel" *ngIf="activeSelectedUser">
              <div class="rights-header">
                <div class="tableheader">{{'Access rights for'|translate}} {{activeSelectedUser.name}}</div>
              </div>
              <div class="presets-row">
                <span class="presets-title">{{'Presets of access rights'|translate}}</span>
                <button class="btn_preset" *ngFor="let preset of aclPresets"
                  [class.active]="activePresetMask === preset.mask" (click)="applyPresetUnified(preset.mask)"
                  [disabled]="!canEditUserAcl(activeSelectedUser)">
                  {{preset.label | translate}}
                </button>
              </div>
              <div class="acl-groups">
                <div class="acl-group" *ngFor="let group of aclGroups">
                  <div class="acl-group-title">{{group.title | translate}}</div>
                  <div class="acl-grid">
                    <label class="acl-item" *ngFor="let acl of group.items">
                      <input type="checkbox" [disabled]="!canEditUserAcl(activeSelectedUser) ||
                                    !canManageMembers() ||
                                    !isAclAllowed(acl.value)" [checked]="isAclSet(activeSelectedUser, acl.value)"
                        (change)="onAclChangeUnified(activeSelectedUser, acl.value, $event)" />
                      <span>{{acl.label | translate}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="rights-panel empty-users" *ngIf="!activeSelectedUser">
              {{'Select user'|translate}}
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>

  <div rightFooterColumn class="dialog-footer">
    <button class="btn_blue" type="button" *ngIf="dialogMode === DialogMode.Edit" (click)="applyAccessChanges()"
      [disabled]="!isAclContextReady">
      {{'Apply'|translate}}
    </button>
    <button class="btn_blue" type="button" *ngIf="dialogMode === DialogMode.Create" (click)="saveGroupEdit()"
      [disabled]="!isAclContextReady">
      {{'Create group'|translate}}
    </button>
    <button class="btn_lgray" type="button" (click)="closeDialog()">{{'Close'|translate}}</button>
  </div>
</app-dialog-base>

<template #objectsListDialog></template>
<template #usersListDialog></template>
